import { useSubscribeToPublicWebsocketEvent } from '~/core/shared/contexts/websockets';
import { AnyDocument } from '../../../../types';
import { buildDocumentChannelName } from '../../logic/buildDocumentChannelName';
import { DocumentPrivateWebsocketEvent } from '../../types/DocumentPrivateWebsocketEvent';
import { DocumentPrivateWebsocketEventPayload } from '../../types/DocumentPrivateWebsocketEventPayload';

export const useSubscribeToDocumentAttachmentUploadStateChanged = (
  documentId: AnyDocument['id'],
  onUpdate: (
    payload: DocumentPrivateWebsocketEventPayload[DocumentPrivateWebsocketEvent.AttachmentUploadStateChanged],
  ) => void,
): void => {
  useSubscribeToPublicWebsocketEvent(
    buildDocumentChannelName(documentId),
    DocumentPrivateWebsocketEvent.AttachmentUploadStateChanged,
    onUpdate,
  );
};
